export const LanguageTypes = {
  en: "en",
  sv: "sv",
} as const;

export type Language = typeof LanguageTypes[keyof typeof LanguageTypes];
